<form [formGroup]="packageForm" (ngSubmit)="onSubmit()">
    <div class="bg-white rounded-lg py-3 mb-6">
        <div class="flex justify-between items-center mt-3 mb-6 px-6">
            <h1>{{ isEditMode ? 'Update Package' : 'Create Package' }}</h1>
        </div>

        <div class="user-group grid grid-cols-12 border-t-2 pt-4 px-6 gap-8 p-2">
            <!-- Package Name -->
            <div class="col-span-6">
                <mat-label>Package Name</mat-label>
                <mat-form-field appearance="outline" class="w-full">
                    <input matInput formControlName="package_name"
                        [ngClass]="{ 'is-invalid': submitted && f['package_name'].errors }" />
                    <mat-error
                        *ngIf="(f['package_name'].touched || submitted) && f['package_name'].errors?.['required']">
                        Package Name is required
                    </mat-error>
                </mat-form-field>
            </div>

            <!-- Amount -->
            <div class="col-span-6">
                <mat-label>Srq Amount</mat-label>
                <mat-form-field appearance="outline" class="w-full">
                    <input matInput type="number" formControlName="sqr_amount"
                        [ngClass]="{ 'is-invalid': submitted && f['sqr_amount'].errors }" />
                    <mat-error *ngIf="submitted && f['sqr_amount'].errors?.['required']">Amount is required</mat-error>
                </mat-form-field>
            </div>

            <!-- User Count -->
            <div class="col-span-6">
                <mat-label>User Count</mat-label>
                <mat-form-field appearance="outline" class="w-full">
                    <input matInput type="number" formControlName="user_count"
                        [ngClass]="{ 'is-invalid': submitted && f['user_count'].errors }" />
                    <mat-error *ngIf="submitted && f['user_count'].errors?.['required']">User Count is
                        required</mat-error>
                </mat-form-field>
            </div>

            <!-- User Count -->
            <div class="col-span-6">
                <mat-label>Per User Price</mat-label>
                <mat-form-field appearance="outline" class="w-full">
                    <input matInput type="number" formControlName="per_user_price"
                        [ngClass]="{ 'is-invalid': submitted && f['per_user_price'].errors }" />
                    <mat-error *ngIf="submitted && f['per_user_price'].errors?.['required']">Per User Price is
                        required</mat-error>
                </mat-form-field>
            </div>
            <!-- Project Count -->
            <div class="col-span-6">
                <mat-label>Project Count</mat-label>
                <mat-form-field appearance="outline" class="w-full">
                    <input matInput type="number" formControlName="project_count"
                        [ngClass]="{ 'is-invalid': submitted && f['project_count'].errors }" />
                    <mat-error *ngIf="submitted && f['project_count'].errors?.['required']">Project Count is
                        required</mat-error>
                </mat-form-field>
            </div>

            <!-- Invoice Count -->
            <!-- <div class="col-span-6">
                <mat-label>Invoice Count</mat-label>
                <mat-form-field appearance="outline" class="w-full">
                    <input matInput type="number" formControlName="invoice_count"
                        [ngClass]="{ 'is-invalid': submitted && f['invoice_count'].errors }" />
                    <mat-error *ngIf="submitted && f['invoice_count'].errors?.['required']">Invoice Count is
                        required</mat-error>
                </mat-form-field>
            </div> -->

            <!-- Duration -->
            <!-- <div class="col-span-6">
                <mat-label>Duration</mat-label>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-select formControlName="duration">
                        <mat-option *ngFor="let option of durationOptions" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="submitted && f['duration'].errors?.['required']">
                        Duration is required
                    </mat-error>
                </mat-form-field>
            </div> -->

            <!-- Description with ngx-editor -->
            <!-- <div class="col-span-12">
                <mat-label>Inclusions</mat-label>
                <div class="border rounded p-2">
                    <ngx-editor-menu [editor]="descriptionEditor" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="descriptionEditor" formControlName="description"></ngx-editor>
                </div>
                <mat-error *ngIf="submitted && f['description'].errors?.['required']">
                    Description is required
                </mat-error>
            </div> -->

            <!-- <div class="col-span-12">
                <mat-label>Exclusions</mat-label>
                <div class="border rounded p-2">
                    <ngx-editor-menu [editor]="sExclusionEditor" [toolbar]="toolbar"></ngx-editor-menu>
                    <ngx-editor [editor]="sExclusionEditor" formControlName="s_exclusion"></ngx-editor>
                </div>
                <mat-error *ngIf="submitted && f['s_exclusion'].errors?.['required']">
                Exclusion is required
                </mat-error>
            </div> -->

            <!-- Submit Button -->
            <div class="col-span-12 text-right mt-4">
                <button mat-raised-button color="primary" type="submit">
                    {{ isEditMode ? 'Update' : 'Create' }}
                </button>
            </div>
        </div>
    </div>
</form>